export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Алушы"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жасаушы"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Алушы ID"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жасаушы ID"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сіз төлейсіз"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сіз аласыз"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Күту уақыты"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Аты"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Банк шоты/Әмиян"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сипаттама"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Банк аты жоқ"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Банк шоты жоқ"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ат көрсетілмеген"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Шот көрсетілмеген"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сыртқы"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ішкі"])}
}